import { Theme } from '@mui/material'

const useStyles = {
  placementSuggestionsContainer: (theme: Theme) => ({
    color: theme.palette.common.white,
  }),
  sensorImg: {
    width: '100%',
  },
  imageContainer: (theme: Theme) => ({
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      marginLeft: '-16px',
      marginRight: '-16px',
    },
  }),
  text: {
    fontWeight: 300,
    lineHeight: 1.5,
    letterSpacing: 0,
  },
  textEmphasis: {
    fontWeight: 700,
    fontStyle: 'italic',
  },
  centerAlign: () => ({
    display: 'flex',
    justifyContent: 'center',
  }),
  shortScreenMargin: (theme: Theme) => ({
    marginTop: theme.spacing(-2.5),
  }),
  whereToPlaceText: (theme: Theme) => ({
    fontSize: '13px',
    fontWeight: 500,
    fontStyle: 'italic',
    lineHeight: 1.2,
    letterSpacing: 0,
    color: theme.palette.ui.tertiaryFixedDim,
  }),
  probePlacementModalSubtitle: (theme: Theme) => ({
    color: theme.palette.tertiary.main,
  }),
  lfOuterContainer: {
    flexDirection: 'column',
    gap: '28px',
    marginTop: 4,
  },
  lfTextContainer: {
    flexDirection: 'column',
    gap: 1,
    paddingX: 2,
  },
  lfHeading: {
    fontWeight: '300',
  },
  lfImagesContainer: {
    gap: 2,
    alignItems: 'start',
    justifyContent: 'center',
  },
  lfImageItem: {
    mb: -1,
  },
  nextButtonPaddingX: {
    paddingX: 4,
  },
  slimOuterContainer: {
    gap: '54px',
  },
  slimSectionWithMargin: (isShortScreen: boolean) => ({
    gap: '16px',
    ...(isShortScreen && { marginTop: '-20px' }),
  }),
  slimSection: {
    gap: '16px',
  },
  slimTextColumn: {
    flexDirection: 'column',
    gap: '8px',
  },
  probeOuterContainer: (isMobile: boolean) => ({
    flexDirection: 'column',
    paddingX: isMobile ? 2 : 0,
    gap: 3,
  }),
  probeSectionColumn: {
    flexDirection: 'column',
    gap: 1,
  },
  probeSubtitle: {
    fontSize: '13px',
    fontWeight: '500',
    fontStyle: 'italic',
  },
  probeBodyText: {
    fontWeight: '300',
  },
}

export default useStyles
